import type { ComponentProps } from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cn } from '@shared/lib';

export type DividerProps = ComponentProps<typeof SeparatorPrimitive.Root>;

/**
 * Thin rule separating content. Horizontal by default; pass `orientation="vertical"`
 * inside a flex row. Decorative by default (hidden from the a11y tree).
 */
export function Divider({
  className,
  orientation = 'horizontal',
  decorative = true,
  ...props
}: DividerProps) {
  return (
    <SeparatorPrimitive.Root
      data-slot="divider"
      orientation={orientation}
      decorative={decorative}
      className={cn(
        'shrink-0 bg-border',
        orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
        className,
      )}
      {...props}
    />
  );
}
